module.exports = __webpack_public_path__ + "img/feat_2.9ddf745a.png";